const ONES = [
  "",
  "Satu",
  "Dua",
  "Tiga",
  "Empat",
  "Lima",
  "Enam",
  "Tujuh",
  "Delapan",
  "Sembilan",
  "Sepuluh",
  "Sebelas",
];

function spellInteger(n: number): string {
  if (n < 12) return ONES[n];
  if (n < 20) return `${spellInteger(n - 10)} Belas`;
  if (n < 100) return `${spellInteger(Math.floor(n / 10))} Puluh ${spellInteger(n % 10)}`.trim();
  if (n < 200) return `Seratus ${spellInteger(n - 100)}`.trim();
  if (n < 1000) return `${spellInteger(Math.floor(n / 100))} Ratus ${spellInteger(n % 100)}`.trim();
  if (n < 2000) return `Seribu ${spellInteger(n - 1000)}`.trim();
  if (n < 1000000)
    return `${spellInteger(Math.floor(n / 1000))} Ribu ${spellInteger(n % 1000)}`.trim();
  if (n < 1000000000)
    return `${spellInteger(Math.floor(n / 1000000))} Juta ${spellInteger(
      n % 1000000
    )}`.trim();
  return `${spellInteger(Math.floor(n / 1000000000))} Miliar ${spellInteger(
    n % 1000000000
  )}`.trim();
}

/**
 * Konversi angka rupiah ke terbilang, mis. 1930000 -> "Satu Juta Sembilan
 * Ratus Tiga Puluh Ribu Rupiah"
 */
export function terbilang(value: number): string {
  const rounded = Math.round(value);

  // Guard terhadap NaN/Infinity (mis. grandTotal belum ke-load dari API):
  // tanpa ini, semua perbandingan "n < X" di spellInteger selalu false untuk
  // NaN, jadi selalu jatuh ke branch Miliar yang manggil dirinya sendiri
  // dengan NaN lagi -> infinite recursion / stack overflow.
  if (!Number.isFinite(rounded)) return "Nol Rupiah";

  if (rounded === 0) return "Nol Rupiah";

  const words = spellInteger(rounded).replace(/\s+/g, " ").trim();

  return `${words} Rupiah`;
}